
function Loader(props) {
    return (
        <div className="dotLoader">
            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
    )
}
export default Loader;